<template>
    <Dialog v-model:open="opened">
        <DialogTrigger>
            <slot />
        </DialogTrigger>
        <DialogContent>
            <DialogHeader>
                <DialogTitle>
                    {{ $t("integrations.close.modal.title") }}</DialogTitle
                >
            </DialogHeader>
            <div class="mt-3 w-full text-center sm:mt-0 sm:text-left">
                <h3
                    id="modal-title"
                    class="text-lg font-medium leading-6 text-iron-900"
                ></h3>
                <div class="mt-2">
                    <div class="mt-4">
                        <label
                            for="workflow-name"
                            class="block text-sm font-medium text-iron-700"
                            >{{
                                $t("integrations.close.modal.nameLabel")
                            }}</label
                        >
                        <div class="mt-1 w-full">
                            <input
                                v-model="integrationName"
                                type="text"
                                data-cy="new-workflow-name"
                                name="workflow-name"
                                class="block w-full rounded-md border-iron-300 shadow-sm focus:border-z-orange-500 focus:ring-z-orange-500 sm:text-sm"
                                :placeholder="
                                    $t(
                                        'integrations.close.modal.name_placeholder',
                                    )
                                "
                            />
                        </div>
                    </div>

                    <div class="mt-4">
                        <label
                            for="workflow-name"
                            class="block text-sm font-medium text-iron-700"
                            >{{
                                $t("integrations.close.modal.apiKeyLabel")
                            }}</label
                        >
                        <div class="mt-1 w-full">
                            <input
                                v-model="apiKey"
                                type="text"
                                data-cy="new-workflow-name"
                                name="workflow-name"
                                class="block w-full rounded-md border-iron-300 shadow-sm focus:border-z-orange-500 focus:ring-z-orange-500 sm:text-sm"
                                :placeholder="
                                    $t(
                                        'integrations.close.modal.api_key_placeholder',
                                    )
                                "
                            />
                        </div>
                    </div>
                </div>
            </div>

            <DialogFooter
                class="w-full"
                :class="[removable ? '!justify-between' : 'justify-end']"
            >
                <Button
                    v-if="removable"
                    @click="$emit('remove-integration')"
                    variant="destructive"
                    class="block"
                >
                    <Trash :size="16" />
                </Button>
                <ZButton
                    class="ml-4"
                    type="button"
                    @click="createEcomailIntegration"
                    >{{ $t("integrations.close.add_api_key") }}</ZButton
                >
            </DialogFooter>
        </DialogContent>
    </Dialog>
</template>

<script setup lang="ts">
import ZButton from "./../../Atomic/Button.vue";
import { ref } from "vue";
import { router } from "@inertiajs/vue3";
import { Button } from "@/components/ui/button";
import { Trash } from "lucide-vue-next";
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";

const props = defineProps<{
    removable?: boolean;
    integration?: any;
}>();

const opened = ref(false);

const integrationName = ref(props.integration?.name || "");
const apiKey = ref(props.integration?.data?.apiKey || "");

const createEcomailIntegration = function () {
    router.post(
        "/close-integrations",
        {
            name: integrationName.value,
            apiKey: apiKey.value,
        },
        {
            onFinish: () => {
                closeModal();
            },
        },
    );
};

const closeModal = () => {
    opened.value = false;
};
</script>

<style></style>
